<template>
  <div id="totalBox">
    <div class="analyseBox">
      <div class="analyseContent">
        <p class="analyseContentTitle">【2019年中国停车市场需求规模及发展趋势预测分析】</p>
        <div class="analyseContentText">
          <div>
            <span style="font-weight: bold;">中商情报网讯：</span>近年来，国民经济增长，居民消费水平日益增高，汽车在中国家庭的普及已十分广泛。据数据显示，2018年我国汽车工业总体运行平稳，受政策因素和宏观经济的影响，产销量低于年初预期，全年汽车产销分别完成2780.9万辆和2808.1万辆，连
                      续十年蝉联全球第一。
          </div>
          <p class="backgroundTip">在此背景下，汽车保有量也在持续攀升。</p>
          <div class="parkNeed">
                      汽车保有量不断增长，停车设施需求也随之扩大。据预测，2018年我国停车位需求了将近3亿个。随着汽车保有量的进一步提高，到2019年停车位需求或将达3.3亿个。
          </div>
          <p class="developTitle">停车产业发展趋势</p>
          <div class="developList">（一）产业规模迎来持续增长</div>
          <div class="developList">（二）停车设施的“立体化”</div>
          <div class="developList">（三）停车场运营专业化</div>
          <div class="developList">（四）停车产业智慧化</div>
          <div class="developList">（五）停车设施建设审批流程高效化</div>
        </div>
      </div>
      <div class="ckBox">
        <p class="ckTitle">什么是创客？</p>
        <div class="ckLine"></div>
        <ul class="ckContent">
          <li class="ckList">“创客”是指勇于创新</li>
          <li class="ckList">努力将自己的创意变为现实的人</li>
          <li class="ckList">创客与其说是一种称呼，</li>
          <li class="ckList">不如说，</li>
          <li class="ckList">是一种信仰，</li>
          <li class="ckList">一旦创新成为信仰，</li>
          <li class="ckList">一切险阻都将化为坦途！</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  naem: 'Ckanalyse',
  data: function () {
    return {
      msg: '2'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 780px;
  background:rgba(249,249,249,1);
}
.analyseBox{
  width: 1200px;
  margin: 0 auto;
  height: 100%;
  padding-top: 45px;
  position: relative;
}
.analyseContent{
  width:860px;
  height:620px;
  background:rgba(255,255,255,1);
  box-shadow:0px 6px 10px 0px rgba(35,24,21,0.08);
  text-align: left;
  padding: 0 29px;
  padding-top: 40px;
}
.analyseContentTitle{
  font-size:30px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.analyseContentText{
  width: 612px;
  margin-top: 30px;
  font-size:16px;
  color:rgba(86,86,86,1);
  line-height:28px;
  padding-left: 12px;
}
.backgroundTip{
  font-size:16px;
  font-weight:bold;
  color:rgba(86,86,86,1);
  margin: 15px 0;
}
.parkNeed{
  font-size:16px;
  font-weight:400;
  color:rgba(86,86,86,1);
  line-height:28px;
}
.developTitle{
  font-size:20px;
  font-weight:bold;
  color:rgba(86,86,86,1);
  line-height:28px;
  margin-top: 15px;
}
.developList{
  font-size:16px;
  font-weight:400;
  color:rgba(86,86,86,1);
  line-height:28px;
  margin-top: 12px;
}
.ckBox{
  width:520px;
  height:560px;
  background:rgba(242,56,56,1);
  box-shadow:0px 8px 30px 0px rgba(35,24,21,0.08);
  position: absolute;
  right: 0;
  bottom: 45px;
  padding-top: 70px;
}
.ckTitle{
  font-size:40px;
  font-weight:bold;
  color:rgba(255,255,255,1);
}
.ckLine{
  width:80px;
  margin: 0 auto;
  margin-top: 18px;
  height:4px;
  background:rgba(255,255,255,1);
}
.ckContent{
  width: 100%;
  margin-top: 40px;
}
.ckList{
  font-size:22px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:45px;
}
</style>



// WEBPACK FOOTER //
// src/components/ck/ckanalyse.vue